
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.5798 16.09L20.4898 8.43C20.2098 6.46 18.5198 5 16.5298 5H7.46982C5.47982 5 3.78982 6.46 3.50982 8.43L2.41982 16.09C2.19982 17.63 3.38982 19 4.93982 19C5.61982 19 6.25982 18.73 6.73982 18.25L8.99982 16H14.9998L17.2498 18.25C17.7298 18.73 18.3798 19 19.0498 19C20.6098 19 21.7998 17.63 21.5798 16.09ZM10.9998 11H8.99982V13H7.99982V11H5.99982V10H7.99982V8H8.99982V10H10.9998V11ZM14.9998 10C14.4498 10 13.9998 9.55 13.9998 9C13.9998 8.45 14.4498 8 14.9998 8C15.5498 8 15.9998 8.45 15.9998 9C15.9998 9.55 15.5498 10 14.9998 10ZM16.9998 13C16.4498 13 15.9998 12.55 15.9998 12C15.9998 11.45 16.4498 11 16.9998 11C17.5498 11 17.9998 11.45 17.9998 12C17.9998 12.55 17.5498 13 16.9998 13Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-sports-esports`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSportsEsports

    ```js
    <b-new-b-icon-sports-esports />
    ```
</docs>


